import { isValidCron } from 'cron-validator'

export function validateCron(expression: string): string | null {
  const trimmed = expression.trim()
  if (!trimmed) return 'Cron expression is required'
  return isValidCron(trimmed, { seconds: true }) ? null : 'Invalid cron expression'
}
